import {
  Key, CheckCircle, AlertTriangle, Settings,
} from 'lucide-react'
import { StatsCard } from '@/components/dashboard/StatsCard'
import { DashboardSectionHeader } from '@/components/dashboard/DashboardSectionHeader'
import { useInfrastructureStats } from '@/hooks/useInfrastructureStats'

export function InfrastructureSection() {
  const { data, isLoading } = useInfrastructureStats()

  return (
    <div>
      <DashboardSectionHeader
        icon={Settings}
        title="Infrastructure"
      />
      <div className="grid gap-3 sm:gap-4 grid-cols-2 lg:grid-cols-4">
        <StatsCard
          title="Vanity Mints Generated"
          value={data?.vanityTotal.toLocaleString() || '0'}
          icon={Key}
          loading={isLoading}
        />
        <StatsCard
          title="Vanity Mints Used"
          value={data?.vanityUsed.toLocaleString() || '0'}
          icon={Key}
          warning={
            data && data.vanityUsed === 0 && data.vanityTotal > 0
              ? 'Upstream sync may need attention'
              : undefined
          }
          loading={isLoading}
        />
        <StatsCard
          title="Vanity Mints Available"
          value={data?.vanityAvailable.toLocaleString() || '0'}
          icon={Key}
          warning={data && data.vanityAvailable < 100 ? 'Low vanity mint inventory' : undefined}
          loading={isLoading}
        />
        <StatsCard
          title="Verified Tokens"
          value={data?.verifiedTokens.toLocaleString() || '0'}
          icon={CheckCircle}
          loading={isLoading}
        />
      </div>

      {/* Pending Fee Routes warning banner */}
      {data && data.pendingFeeRoutes > 0 && (
        <div className="mt-3 flex items-center gap-2 rounded-lg border border-amber-500/30 bg-amber-500/10 p-3">
          <AlertTriangle className="h-4 w-4 text-amber-500 shrink-0" />
          <span className="text-sm text-amber-500">
            {data.pendingFeeRoutes} pending fee route{data.pendingFeeRoutes !== 1 ? 's' : ''} awaiting processing
          </span>
        </div>
      )}
    </div>
  )
}
